import { render, staticRenderFns } from "./ShowResult.vue?vue&type=template&id=12a9b01b&scoped=true&"
import script from "./ShowResult.vue?vue&type=script&lang=js&"
export * from "./ShowResult.vue?vue&type=script&lang=js&"
import style0 from "./ShowResult.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ShowResult.vue?vue&type=style&index=1&id=12a9b01b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12a9b01b",
  null
  
)

export default component.exports